import React from 'react';
import { IoWarning } from 'react-icons/io5';
import type { ProcessingError } from './OperationPageViewBackend';

interface ProcessingErrorsBannerProps {
    errors: ProcessingError[] | null | undefined;
}

const ProcessingErrorsBanner: React.FC<ProcessingErrorsBannerProps> = ({ errors }) => {
    if (!errors || errors.length === 0) return null;

    return (
        <div className="mb-4 p-4 bg-red-50 border border-red-300 rounded dark:bg-red-900/30 dark:border-red-600">
            <div className="flex items-center gap-2 mb-2">
                <IoWarning className="text-red-500 w-5 h-5 flex-shrink-0" />
                <strong className="text-red-700 dark:text-red-300">Erros no processamento de arquivos XML ({errors.length})</strong>
            </div>
            <ul className="list-disc list-inside space-y-1 text-sm text-red-600 dark:text-red-400">
                {errors.map((err, idx) => (
                    <li key={idx}>
                        <span className="font-medium">{err.file_name}</span>: {err.error}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ProcessingErrorsBanner;
